import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AbstractControl, FormBuilder, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { TbsButtonModule } from '@ngx-terabase/ui/button';
import { MissionService } from 'src/app/services/mission.service';
import { MissionCreationResult } from '../new-mission/new-mission.component';
import { TbsFormModule } from '@ngx-terabase/ui/form';
import { TbsInputModule } from '@ngx-terabase/ui/input';



export function s3UriValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value || typeof value !== 'string') {
      return null; 
    }

    if (!value.startsWith('s3://')) {
      return { invalidS3Uri: 'S3 URI must start with "s3://"' };
    }

    return null;
  };
}


@Component({
  selector: 'app-s3-url-upload',
  imports: [
    TbsButtonModule,
    ReactiveFormsModule,
    TbsFormModule,
    TbsInputModule,
  ],
  templateUrl: './s3-url-upload.component.html',
  styleUrl: './s3-url-upload.component.scss',
  standalone: true,
})
export class S3UrlUploadComponent {
  @Input() public missionCreationResult!: MissionCreationResult;
  @Output() public s3UploadFinish = new EventEmitter<void>();

  private missionService = inject(MissionService);
  private fb = inject(FormBuilder);

  public form = this.fb.group({ url: ['', [Validators.required, s3UriValidator()]] });

  startProcessing() {
    this.missionService
      .startMissionProcessing(
        this.missionCreationResult,
        this.form.getRawValue().url!
      )
      .subscribe({
        next: () => this.s3UploadFinish.emit(),
      });
  }
}
